import { Outlet } from 'react-router-dom'
import Thirdgrade_k3_subjects from './thirdgrade_k3_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Thirdgrade_k3 = ( ) => {
 
  return (
    <>
   
   
  <TopNavbar />
  <Thirdgrade_k3_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Thirdgrade_k3;